/* eslint-env browser */
import * as React from 'react'

import { getCDNUrl } from '../../../../../../shared/services/media-helper'

const PropTypes = require('prop-types')
const classNames = require('classnames')

class SpeciesList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { customItemClassName, species } = this.props

    return (
      <div className="has-padding-top-small has-padding-bottom-xsmall">
        {species.map(oneSpecies => (
          <div key={oneSpecies.id} className={classNames('media', customItemClassName)}>
            {oneSpecies.medias && oneSpecies.medias.length > 0 && (
              <figure className="media-left">
                <a href={`/fish/${oneSpecies.seoName}`}>
                  <p className="image" style={{ maxWidth: 64, maxHeight: 32 }}>
                    <img
                      src={getCDNUrl(oneSpecies.medias[0], 'small', { name: oneSpecies.seoName, type: 'fishSpecies' })}
                      className="has-object-fit-contain"
                      alt={oneSpecies.name}
                    />
                  </p>
                </a>
              </figure>
            )}
            <div className="media-content is-self-centered">
              <a href={`/fish/${oneSpecies.seoName}`} className="has-text-weight-bold has-text-break-word">
                {oneSpecies.name}
              </a>
              <div className="is-size-8 has-text-grey has-text-break-word">
                {[oneSpecies.sciGenus, oneSpecies.sciSpecies, oneSpecies.sciAdditional]
                  .filter(elt => !!elt && elt.length > 0)
                  .join(' ')}
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }
}

SpeciesList.propTypes = {
  species: PropTypes.array,
  customItemClassName: PropTypes.string,
}

SpeciesList.defaultProps = {
  species: [],
  customItemClassName: null,
}

module.exports = SpeciesList
